export const shops = [
  {
    name: 'Shop',
    url: '/base/shop',
    icon: 'fa fa-cube'
  },
  {
    name: 'Create Shop',
    url: '/base/shop/create',
    icon: 'icon-plus'
  }
];
